import axios from 'axios';
import { USER_ROLE, TARIFFS } from 'constants';
import i18n from './i18n';


export const addUrlProtocol = (url, protocol = 'https') => (
  url ?
  `${protocol}://${url.replace(/(http|https):\/\//, '')}` :
  url
);

export const pluralize = (n, one, few, many) => {
  const num = n ? Number(n) : 0;
  if (num >= 10 && num <= 19) return many;

  const lastDigit = num % 10;
  if (lastDigit === 1) return one;
  if (lastDigit >= 2 && lastDigit <= 4) return few;
  return many;
};

export const formatPhoneNumber = (s) => {
  const s2 = (`${s}`).replace(/\D/g, '');
  const m = s2.match(/^(7|8)(\d{3})(\d{3})(\d{2})(\d{2})$/);
  return (!m) ? s : `${m[1] === '7' ? '+7' : '8'} (${m[2]}) ${m[3]}-${m[4]}-${m[5]}`;
};

export const formatNumber = (s, separator = ' ') => {
  const parts = s.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  return parts.join('.');
};

export const parseQuery = (query) => query
    ? query
      .replace(/^\?/, '')
      .split('&')
      .reduce((prev, cur) => {
        const [key, value] = cur.split('=');
        if (key) {
          prev[key] = value;
        }
        return prev;
      }, {})
    : {};
const typeFilters = ['new', 'viewAction', 'orderField', 'blackList'];

export const compileQuery = (params, query, options = {}) => {
  if (compileQuery.lastParams === params && compileQuery.lastQuery === query) {
    return compileQuery.cache;
  }
  compileQuery.lastParams = params;
  compileQuery.lastQuery = query;
  const prevParams = parseQuery(query);
  let nextParams = { ...prevParams };
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value == null || typeFilters.includes(value)) {
      delete nextParams[key];
    } else {
      nextParams[key] = value;
    }
  });
  if (options.withoutTypeFilters) {
    Object.keys(nextParams).forEach(key => typeFilters.includes(key) && delete nextParams[key]);
  }

  compileQuery.cache = Object.keys(nextParams)
  .reduce((prev, cur) => {
    prev.push(`${cur}=${nextParams[cur]}`);
    return prev;
  }, [])
  .join('&');

  return compileQuery.cache;
};

export const initAxios = (token) => {
  // header('Content-type: text/html; charset=utf-8');
  window.axios = axios;
  if (token) {
    axios.defaults.headers.common['x-api-token'] = token;
  } else {
    delete axios.defaults.headers.common['x-api-token'];
  }
};

export const monthToString = (month) => {
  if (month >= 0 && month <= 11) {
    return i18n.t(`utils.monthToString.${month}`);
  }

  return '';
};

export const updateString = (updated) => {
  if (!updated) {
    return null;
  }

  const date = new Date(updated * 1000);
  date.setHours((date.getHours() + 3)); // Cast from Moscow Time to UTC, may be a server-side problem?
  const now = new Date();

  if (date.toDateString() === now.toDateString()) {
    return i18n.t('utils.updateString.todayAt', {
      time: date.toTimeString().slice(0, 5)
    });
  } else if (date.getFullYear() === now.getFullYear()) {
    return `${date.getDate()} ${monthToString(date.getMonth())}`;
  }
  return `${date.getDate()} ${monthToString(date.getMonth())} ${date.getFullYear()}`;
};

export const updateStringPrint = (updated) => {
  if (!updated) {
    return null;
  }
  const date = new Date(updated * 1000);
  date.setHours((date.getHours() + 3)); // Cast from Moscow Time to UTC, may be a server-side problem?
  const now = new Date();

  if (date.getFullYear() === now.getFullYear()) {
    return `${date.getDate()} ${monthToString(date.getMonth())}`;
  }
  return `${date.getDate()} ${monthToString(date.getMonth())} ${date.getFullYear()}`;
};

export const formatDate = (d) => {
  const date = new Date(d.replace(/-/g, '/')); // Fix for safari
  const day = new Date();
  if (date.toDateString() === day.toDateString()) {
    return i18n.t('utils.formatDate.today');
  }
  day.setDate(day.getDate() - 1);
  if (date.toDateString() === day.toDateString()) {
    return i18n.t('utils.formatDate.yesterday');
  }
  return `${date.getDate()} ${monthToString(date.getMonth())}${date.getFullYear() < day.getFullYear() ? ` ${date.getFullYear()}` : ''}`;
};

export const formatTime = (d) => {
  const date = new Date(d.replace(/-/g, '/')); // Fix for safari
  date.setHours((date.getHours()));
  return date.toTimeString().slice(0, 5);
};

export const getUserRole = ({ agencyName, roleName }) => {
  if (roleName === 'owner') {
    return USER_ROLE.ADMIN;
  }
  if (roleName === 'agent' && agencyName) {
    return USER_ROLE.WORKER;
  }
  if (roleName === 'agent' && !agencyName) {
    return USER_ROLE.INDIVIDUAL;
  }
};

export const getTarifName = (name) => {
  switch (name) {
    case TARIFFS.COMPANY:
      return i18n.t('utils.getTarifName.company');
    case TARIFFS.PERSONAL:
      return i18n.t('utils.getTarifName.personal');
    case TARIFFS.COMPANY_TEST:
      return i18n.t('utils.getTarifName.test');
    case TARIFFS.PERSONAL_TEST:
      return i18n.t('utils.getTarifName.test');
    default:
      console.warn('No such tarif name: ', name);
      return i18n.t('utils.getTarifName.test');
  }
};

export const getTarifPeriodName = (name) => {
  switch (name) {
    case TARIFFS.COMPANY:
      return i18n.t('utils.getTarifPeriodName.company');
    case TARIFFS.PERSONAL:
      return i18n.t('utils.getTarifPeriodName.company');
    case TARIFFS.COMPANY_TEST:
      return i18n.t('utils.getTarifPeriodName.test');
    case TARIFFS.PERSONAL_TEST:
      return i18n.t('utils.getTarifPeriodName.test');
    default:
      console.warn('No such tarif name: ', name);
      return i18n.t('utils.getTarifPeriodName.test');
  }
};



// WEBPACK FOOTER //
// ./src/utils.js